import { h } from 'preact';
import { CheckboxEntry, SelectEntry } from '@epx/flow';

const getApprovalOptions = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'Agreed', label: i18n['opt.Agreed'] || 'Agreed' },
  { value: 'Refused', label: i18n['opt.Refused'] || 'Refused' },
];

const getReceiverTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'default', label: i18n['opt.receiverDefault'] || 'Default' },
  { value: 'superior', label: i18n['opt.superior'] || 'Superior' },
  { value: 'previous', label: i18n['opt.previous'] || 'Previous Step' },
];

export class SfdTransitionExtension {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:SequenceFlow';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('edge:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'sfdTransition',
        label: i18n.sfdTransition || 'SFD Transition',
        isEdited: () => !!(props.defaultBranch === true || props.defaultBranch === 'true' || props.recieverType || props.approval || props.forcedMerge === true || props.forcedMerge === 'true'),
        entries: [
          {
            id: 'defaultBranch',
            component: () => (
              <CheckboxEntry
                id="sfd-defaultBranch"
                label={i18n.defaultBranch || 'Default Branch'}
                checked={props.defaultBranch === true || props.defaultBranch === 'true'}
                onChange={(val) => update('defaultBranch', val)}
              />
            ),
          },
          {
            id: 'recieverType',
            component: () => (
              <SelectEntry
                id="sfd-recieverType"
                label={i18n.recieverType || 'Receiver Type'}
                value={props.recieverType || ''}
                options={getReceiverTypes(i18n)}
                onChange={(val) => update('recieverType', val)}
              />
            ),
          },
          {
            id: 'approval',
            component: () => (
              <SelectEntry
                id="sfd-approval"
                label={i18n.approval || 'Approval'}
                value={props.approval || ''}
                options={getApprovalOptions(i18n)}
                onChange={(val) => update('approval', val)}
              />
            ),
          },
          {
            id: 'forcedMerge',
            component: () => (
              <CheckboxEntry
                id="sfd-forcedMerge"
                label={i18n.forcedMerge || 'Forced Merge'}
                checked={props.forcedMerge === true || props.forcedMerge === 'true'}
                onChange={(val) => update('forcedMerge', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
